var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLexus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2a29",
    d: "M256 94c27 0 54 3 78 9-27 39-80 113-104 146l-8 10s-33 46 29 46h183c5-13 7-27 7-41 0-59-42-110-102-135 6-7 11-14 14-20 82 27 140 86 140 155 0 25-8 49-21 71H204s-86-1-42-76c36-62 85-125 102-146h-10c-103 0-187 68-187 152s84 152 187 152c65 0 123-27 156-69h52c-41 52-119 87-208 87-132 0-238-76-238-170S123 95 254 95z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLexus);
export default __webpack_public_path__ + "static/media/lexus.c2cde80bfd7af83be90f61992c4f397a.svg";
export { ForwardRef as ReactComponent };